<template>
  <aside-container class="team-detail">
    <template v-if="team">
      <div
        slot="header"
        class="d-flex flex-column align-items-center bg-white p-3"
      >
        <img
          v-if="team.avatar"
          :src="team.avatar"
          :alt="team.name"
          width="80"
          height="80"
          class="participant-detail-avatar rounded-circle mb-3"
        >
        <StatusBadge
          v-if="team.status"
          :value="team.status"
          class="my-3"
        />
        <h1>{{ team.name }}</h1>
        <PinboardStatusButton
          v-bind="{ type: 'team', id: team.id }"
          class="mt-3"
          icon
        />
      </div>

      <transition name="fade">
        <TeamMemberPaginator :team-id="team.id">
          <template #default="{ members, next, page, lastPage }">
            <LiveLeaderboard
              v-if="members"
              :header="'team.leaderboard'"
              :runners="members"
              :paginate="page < lastPage"
              :min-items="members.length"
              @next="next"
            />
          </template>
        </TeamMemberPaginator>
      </transition>
    </template>

    <div
      v-if="team"
      class="card my-3"
    >
      <div class="card-body text-center">
        <Facts :header="$t('team.infos', [team.name])">
          <FactItem :title="$tc('team.count', 99, [''])">
            <animated-number
              :value="team.count"
              :decimals="0"
            />
          </FactItem>
          <FactItem
            v-if="team.distance >= 0"
            :title="$t('team.distance')"
          >
            {{ team.distance.toFixed(3).slice(0, -2) || '–' }}
          </FactItem>
          <FactItem :title="$t('team.donations')">
            <animated-number
              v-if="team.raised"
              :value="team.raised.eur"
              :decimals="2"
            >
              <template #default="{ value }">
                {{ value | currency(undefined, { currency: 'EUR', minimumFractionDigits: 0 }) }}
              </template>
            </animated-number>
            <div v-else>–</div>
          </FactItem>
        </Facts>

        <div class="mt-3">
          <a
            v-t="'team.showPage'"
            :href="`/teams/${team.id}`"
            class="btn btn-outline-primary w-100"
            target="_blank"
            rel="noopener"
          />
        </div>
      </div>
    </div>

    <TeaserCard class="my-3">
      <template #img>
        <img
          src="@/assets/SI201805060382_news.jpg"
          :alt="$t('supportTeam.header')"
          class="img-fluid w-100 rounded-top"
          width="686"
          height="324"
        >
      </template>
      <template #default>
        <h2
          v-t="'supportTeam.header'"
          class="h5"
        />
        <p v-t="'supportTeam.text'"/>
        <a
          href="#"
          class="btn btn-outline-primary w-100"
          @click.prevent="$root.donate"
        >
          {{ $t('letsGo') }}
        </a>
      </template>
    </TeaserCard>
  </aside-container>
</template>

<script>
import TeamMemberPaginator from '@/components/TeamMemberPaginator.vue'
import LiveLeaderboard from '@/components/LiveLeaderboard.vue'
import Facts from '@/components/location/Facts.vue'
import FactItem from '@/components/location/FactItem.vue'
import StatusBadge from '@/components/StatusBadge.vue'
import PinboardStatusButton from '@/components/PinboardStatusButton.vue'
import TeaserCard from '@/TeaserCard.vue'
import { mapActions, mapGetters } from 'vuex'
import time from '@/filters/time'

export default {
  name: 'TeamDetail',
  time,
  components: {
    TeamMemberPaginator,
    LiveLeaderboard,
    PinboardStatusButton,
    StatusBadge,
    Facts,
    FactItem,
    TeaserCard
  },
  inject: ['subscribeTeam', 'updateMetaTags'],
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  computed: {
    team() {
      const team = this.teamById(this.id)
      if (!team || (team && team.incomplete)) {
        this.getTeamById(this.id)
      }

      if (!team) {
        return undefined
      }

      return team
    },
    ...mapGetters([
      'teamById'
    ])
  },
  watch: {
    id(id, oldId) {
      if (id !== oldId) {
        this.$options.unSubscripe.then((cb) => {
          cb()
          this.$options.unSubscripe = this.subscribeTeam(id)
        })
      }
    },
    team() {
      this.updateMetaTags({ title: this.team?.name })
    }
  },
  mounted() {
    this.$options.unSubscripe = this.subscribeTeam(this.id)
  },
  beforeRemove() {
    this.$options.unSubscripe.then(cb => cb())
    this.$options.unSubscripe = null
  },
  activated() {
    if (!this.$options.unSubscripe) {
      this.$options.unSubscripe = this.subscribeTeam(this.id)
    }
  },
  deactivated() {
    this.$options.unSubscripe.then(cb => cb())
    this.$options.unSubscripe = null
  },
  methods: {
    ...mapActions([
      'getTeamById',
      'donate'
    ])
  }
}
</script>

<style lang="scss">
  .price-item {
    & + .price-item {
      margin-left: map-get($spacers, 1);
      padding-left: map-get($spacers, 2);
      border-left: 1px solid rgba($white, .25)
    }
  }

</style>
